import { gql } from 'apollo-boost';

export const SET_FOLDER_PINNED = gql`
    mutation($data: SetFolderPinnedInput!) {
        setFolderPinned(data: $data) {
            id
            title
            parent
            owner
            before
            isPinned
            pinnedRank
            deletedAt
            lastViewedAt
            lastMovedAt
            manualMessageSortEnabled
            sharingStatus {
                isShared
                shareCount
                isPublished
            }
        }
    }
`;
